<template>
  <div>
    <div class="pt-0 pr-1 pb-4 pl-1 h6 open-sans line-height-golden">
      Her har du mulighed for at vise kunderne de opgaver, du har løst. Du står stærkt, når du viser kunderne, hvad du kan.
      <br><br>Få hjælp til gode billeder af dine projekter – kontakt os for at høre mere.
    </div>
    <dropzone id="myVueDropzone" :options="dropzoneOptions" v-on:vdropzone-success="showSuccess">
    </dropzone>
  </div>
</template>
<script>
import Dropzone from 'vue2-dropzone'
export default {
  name: 'imagefolder',
  components: {
    Dropzone
  },
  data: function () {
    return {
      dropzoneOptions: {
        url: 'https://api.haandvaerker.dk/Supplier/UploadProfileImages',
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        createImageThumbnails: true,
        addRemoveLinks: true,
        renameFile: true,
        dictDefaultMessage: 'Træk filerne hertil eller klik for at vælge filer'
      }
    }
  },
  computed: {
    dropzoneSettings () {
      let defaultValues = {
        thumbnailWidth: 200,
        thumbnailHeight: 200
      }
      Object.keys(this.options).forEach(function (key) {
        defaultValues[key] = this.options[key]
      }, this)
      if (this.awss3 !== null) {
        defaultValues['autoProcessQueue'] = false
        this.isS3 = true
        if (this.options.autoProcessQueue !== undefined) {
          this.wasQueueAutoProcess = this.options.autoProcessQueue
        }
      }
      return defaultValues
    }
  },
  methods: {
    'showSuccess': function (file) {
      console.log('A file was successfully uploaded')
    }
  }
}
</script>


// WEBPACK FOOTER //
// imagefolder.vue?73f5bbb8